module.exports = __webpack_public_path__ + "static/media/Ziggo_PaesiBassi.2b9852da.png";